<template>
  <CommonTask
    :content="nextActionSuggestion.content"
    :owner="nextActionSuggestion.owner"
    :title="nextActionSuggestion.name"
    :date-time="nextActionSuggestion.firstSetUpAt"
    :is-sequence="false"
    :is-deletable="false"
    :link-to-text="i18n.t('general.edit.do')"
    layout-type="minimum"
    @click:editor="handleClickEditor"
  >
    <template #status>
      <BStatus
        :status="nextActionSuggestion.approvalStatus"
        :status-name="$t('nextActionSuggestion.status.none')"
      />
    </template>
  </CommonTask>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { NextActionSuggestion } from '@/api/openapi';
import CommonTask from './CommonTask.vue';

type TProps = {
  nextActionSuggestion: NextActionSuggestion;
};
type TEmit = {
  'click:editor': [];
};

defineProps<TProps>();
const emit = defineEmits<TEmit>();

const i18n = useI18n();

const handleClickEditor = () => {
  emit('click:editor');
};
</script>
